import {takeLatest, all} from 'redux-saga/effects'
import AuthAPI from '../Services/AuthApi'
import API from '../Services/Api'
//import UsersAPI from '../Services/UsersApi'

/* ------------- Types ------------- */

import {StartupTypes} from '../Redux/StartupRedux'

import {AuthTypes} from '../Redux/AuthRedux'

import {UserTypes} from '../Redux/UserRedux'

import {FiltersTypes} from '../Redux/FiltersRedux'

import {PublicationsTypes} from '../Redux/PublicationsRedux'

import {MoreAdsTypes} from '../Redux/MoreAdsRedux'

import {AdvertisersTypes} from '../Redux/AdvertisersRedux'

import {ChartsTypes} from '../Redux/ChartsRedux'

import {FoldersTypes} from '../Redux/FoldersRedux'

import {FiltersTopPerformingTypes} from '../Redux/FiltersTopPerformingRedux'
import {FiltersInterestTypes} from '../Redux/FiltersInterestRedux'
import {InterestsTypes} from '../Redux/InterestsRedux'
import {ListsTypes} from '../Redux/ListsRedux'
import {PublicationCreateTypes} from '../Redux/PublicationCreateRedux'

import {SuggestaFutureTypes} from '../Redux/SuggestHelpRedux'
import {TopPerformingTypes} from '../Redux/TopPerformingRedux'
import {PermissionsTypes} from '../Redux/PermissionsRedux'

import {ReportAdminReduxTypes} from '../Redux/ReportAdminRedux'
import {SuggestHelpAdminReduxTypes} from '../Redux/SuggestHelpAdminRedux'
import {SettingsTypes} from '../Redux/SettingsRedux'

import {BillingHistoryTypes} from '../Redux/BillingHistoryRedux'
import {NotificationsTypes} from '../Redux/NotificationsRedux'

import {CustomersReduxTypes} from '../Redux/CustomersRedux'

//import {ProcessesTypes} from '../Redux/ProcessRedux'
//import {TemplateTypes} from '../Redux/TemplateRedux'
//import {LangTypes} from '../Redux/LangRedux'

/* ------------- Sagas ------------- */

import {startup} from './StartupSagas'

import {
  signIn,
  createUser,
  socialAuth,
  checkEmailHash,
  confirmEmail,
  logout,
  restorePassword,
  resetPassword,
  checkPasswordHash,
  checkSocialHash,
  resendEmail,
  resendCode,
  restorePasswordWithVerify,
  verifyMailRestorePassword,
} from './AuthSagas'

import {
  saveUser,
  updateUserInfo,
  saveUserAvatar,
  // getUsers,
  // getUser,
  // deleteUser,
  // changeProfilePassword,
  // changeUserPassword,
  // getBusinessAreas,
  // getCompanyRoles,
  // getStaffList,
  changeUserEmail,
  confirmChangeEmail,
} from './UserSagas'

import {getFilters, saveFilters, loadFilters, updateFilters, deleteFilters} from './FiltersSagas'

import {
  getPublications,
  getFollowingPublications,
  getFolderPublications,
  getPublication,
  followAuthor,
  savePublication,
  getReportReasons,
  sendReport,
  getFollowingSavedCount,
  getAdvertiserPublications,
  getPreparedPublications,
  getScheduledPublications,
  getListPublications,
  deleteListPublications,
  deleteRestorePublication,
} from './PublicationsSagas'

import {getPublicationMoreAds} from './MoreAdsSagas'

import {getFollowingsAdvertisers, getAdvertisers, getAdvertiser, deleteRestoreAdvertiser} from './AdvertisersSagas'

import {getPerformanceChart, getStatusChart} from './ChartsSagas'

import {getFolders, getFolder, saveFolder, deleteFolder, makeDefaultFolder} from './FoldersSagas'

import {getFiltersTopPerforming} from './FiltersTopPerformingSagas'

import {getFiltersInterestLanguage, getFiltersInterestCategory, getFiltersInterest} from './FiltersInterestSagas'

import {getInterests, getInterestFile, getInterestExample} from './InterestsSagas'

import {getLists, restoreList} from './ListsSagas'

import {
  getPublicationCreate,
  savePublicationCreate,
  deletePublicationCreate,
  saveSeller,
  updateSeller,
  deleteSeller,
  saveSupplier,
  updateSupplier,
  deleteSupplier,
  saveMedia,
  updateMedia,
  deleteMedia,
} from './PublicationCreateSagas'

import {
  getPages,
  sendSuggest,
  sendHelp,
  getTickets,
  getTicketId,
  deleteTicket,
  getReports,
  getReportId,
  deleteReport,
} from './SuggestHelpSagas'

//import {getTopPerfomingPublication, getTopPerfomingPublicationId} from './TopPerformingSagas'

import {
  getTopPerforming,
  getTopPerformingId,
  followAuthorTpp,
  saveTopPerforming,
  getReportTppReasons,
  sendTppReport,
} from './TopPerformingSagas'

import {getPermissions, getPermission, savePermissions, deletePermissions, getPermissionsPages} from './PermissionsSagas'

import {
  getCountries,
  getSubscriptions,
  savePaymentMethod,
  savePaymentMethodMollie,
  buySubscription,
  updateSubscription,
  saveCompanyInfo,
  deleteScheduledSubscription,
  checkDiscountCode,
  checkStatusPayment,
} from './SettingsSagas'

import {getBillingHistory} from './BillingHistorySagas'

import {getNotifications, updateNotifications} from './NotificationsSagas'

import {getCustomers, getCustomerId, deleteCustomer, updateCustomer} from './CustomersSagas'

/* ------------- API ------------- */

// The API we use is only used from Sagas, so we create it here and pass along
// to the sagas which need it.
const authApi = AuthAPI
const api = API
//const usersApi = UsersAPI;

/* ------------- Connect Types To Sagas ------------- */

export default function* root() {
  yield all([
    // some sagas only receive an action
    takeLatest(StartupTypes.STARTUP, startup),

    takeLatest(AuthTypes.SIGN_IN_REQUEST, signIn, authApi),
    takeLatest(AuthTypes.SIGN_UP_REQUEST, createUser, authApi),
    takeLatest(AuthTypes.SOCIAL_AUTH_REQUEST, socialAuth, authApi),
    takeLatest(AuthTypes.CHECK_EMAIL_HASH_REQUEST, checkEmailHash, authApi),
    takeLatest(AuthTypes.CONFIRM_EMAIL_REQUEST, confirmEmail, authApi),
    takeLatest(AuthTypes.LOGOUT, logout, authApi),
    takeLatest(AuthTypes.RESTORE_PASSWORD_REQUEST, restorePassword, authApi),
    takeLatest(AuthTypes.RESTORE_PASSWORD_WITH_VERIFY_REQUEST, restorePasswordWithVerify, authApi),
    takeLatest(AuthTypes.VERIFY_MAIL_RESTORE_PASSWORD_REQUEST, verifyMailRestorePassword, authApi),
    takeLatest(AuthTypes.RESET_PASSWORD_REQUEST, resetPassword, authApi),
    takeLatest(AuthTypes.CHECK_PASSWORD_HASH_REQUEST, checkPasswordHash, authApi),
    takeLatest(AuthTypes.CHECK_SOCIAL_HASH_REQUEST, checkSocialHash, authApi),
    takeLatest(AuthTypes.RESEND_EMAIL_REQUEST, resendEmail, authApi),
    takeLatest(AuthTypes.RESEND_CODE_REQUEST, resendCode, authApi),

    //takeLatest(UserTypes.USERS_REQUEST, getUsers, api, authApi),
    //takeLatest(UserTypes.USER_REQUEST, getUser, api, authApi),
    takeLatest(UserTypes.USER_SAVE_REQUEST, saveUser, api, authApi),
    takeLatest(UserTypes.UPDATE_USER_INFO, updateUserInfo, api, authApi),
    //takeLatest(UserTypes.USER_DELETE_REQUEST, deleteUser, api, authApi),
    //takeLatest(UserTypes.PROFILE_CHANGE_PASSWORD_REQUEST, changeProfilePassword, api, authApi),
    //takeLatest(UserTypes.USER_CHANGE_PASSWORD_REQUEST, changeUserPassword, api, authApi),
    //takeLatest(UserTypes.BUSINESS_AREAS_REQUEST, getBusinessAreas, api, authApi),
    //takeLatest(UserTypes.COMPANY_ROLES_REQUEST, getCompanyRoles, api, authApi),
    //takeLatest(UserTypes.STAFF_NUMBER_REQUEST, getStaffList, api, authApi),
    takeLatest(UserTypes.USER_CHANGE_EMAIL_REQUEST, changeUserEmail, api, authApi),
    takeLatest(UserTypes.USER_CONFIRM_CODE_REQUEST, confirmChangeEmail, api, authApi),
    takeLatest(UserTypes.USER_SAVE_AVATAR_REQUEST, saveUserAvatar, api, authApi),

    takeLatest(PublicationsTypes.PUBLICATIONS_REQUEST, getPublications, api, authApi),
    takeLatest(PublicationsTypes.FOLLOWING_PUBLICATIONS_REQUEST, getFollowingPublications, api, authApi),
    takeLatest(PublicationsTypes.FOLDER_PUBLICATIONS_REQUEST, getFolderPublications, api, authApi),
    takeLatest(PublicationsTypes.PUBLICATION_REQUEST, getPublication, api, authApi),
    takeLatest(PublicationsTypes.FOLLOW_AUTHOR_REQUEST, followAuthor, api, authApi),
    takeLatest(PublicationsTypes.SAVE_PUBLICATION_REQUEST, savePublication, api, authApi),
    takeLatest(PublicationsTypes.REPORT_REASONS_REQUEST, getReportReasons, api, authApi),
    takeLatest(PublicationsTypes.SEND_REPORT_REQUEST, sendReport, api, authApi),
    takeLatest(PublicationsTypes.FOLLOWING_SAVED_COUNT_REQUEST, getFollowingSavedCount, api, authApi),
    takeLatest(PublicationsTypes.ADVERTISER_PUBLICATIONS_REQUEST, getAdvertiserPublications, api, authApi),
    takeLatest(PublicationsTypes.PREPARED_PUBLICATIONS_REQUEST, getPreparedPublications, api, authApi),
    takeLatest(PublicationsTypes.SCHEDULED_PUBLICATIONS_REQUEST, getScheduledPublications, api, authApi),
    takeLatest(PublicationsTypes.LIST_PUBLICATIONS_REQUEST, getListPublications, api, authApi),
    takeLatest(PublicationsTypes.DELETE_LIST_PUBLICATIONS_REQUEST, deleteListPublications, api, authApi),
    takeLatest(PublicationsTypes.DELETE_RESTORE_PUBLICATION_REQUEST, deleteRestorePublication, api, authApi),

    takeLatest(MoreAdsTypes.MORE_ADS_REQUEST, getPublicationMoreAds, api, authApi),

    takeLatest(AdvertisersTypes.ADVERTISERS_REQUEST, getAdvertisers, api, authApi),
    takeLatest(AdvertisersTypes.FOLLOWINGS_ADVERTISERS_REQUEST, getFollowingsAdvertisers, api, authApi),
    takeLatest(AdvertisersTypes.ADVERTISER_REQUEST, getAdvertiser, api, authApi),
    takeLatest(AdvertisersTypes.DELETE_RESTORE_ADVERTISER_REQUEST, deleteRestoreAdvertiser, api, authApi),

    takeLatest(ChartsTypes.CHART_PERFORMANCE_REQUEST, getPerformanceChart, api, authApi),
    takeLatest(ChartsTypes.CHART_STATUS_REQUEST, getStatusChart, api, authApi),

    takeLatest(FoldersTypes.FOLDERS_REQUEST, getFolders, api, authApi),
    takeLatest(FoldersTypes.FOLDER_REQUEST, getFolder, api, authApi),
    takeLatest(FoldersTypes.FOLDER_SAVE_REQUEST, saveFolder, api, authApi),
    takeLatest(FoldersTypes.FOLDER_DELETE_REQUEST, deleteFolder, api, authApi),
    takeLatest(FoldersTypes.FOLDER_MAKE_DEFAULT_REQUEST, makeDefaultFolder, api, authApi),

    //takeLatest(ProcessesTypes.PROCESSES_REQUEST, getProcesses, api, authApi),
    //takeLatest(ProcessesTypes.PROCESS_REQUEST, getProcess, api, authApi),
    //takeLatest(ProcessesTypes.PROCESS_SEND_FILE_REQUEST, sendProcessFile, api, authApi),
    //fork(processSyncStartMonitor),

    // takeLatest(RoleTypes.ROLES_REQUEST, getRoles, api, authApi),

    takeLatest(FiltersTypes.FILTERS_REQUEST, getFilters, api, authApi),
    takeLatest(FiltersTypes.FILTERS_SAVE_REQUEST, saveFilters, api, authApi),
    takeLatest(FiltersTypes.FILTERS_LOAD_REQUEST, loadFilters, api, authApi),
    takeLatest(FiltersTypes.FILTERS_UPDATE_REQUEST, updateFilters, api, authApi),
    takeLatest(FiltersTypes.FILTERS_DELETE_REQUEST, deleteFilters, api, authApi),

    takeLatest(FiltersTopPerformingTypes.FILTERS_TOP_PERFORMING_REQUEST, getFiltersTopPerforming, api, authApi),

    takeLatest(FiltersInterestTypes.FILTERS_INTEREST_LANGUAGE_REQUEST, getFiltersInterestLanguage, api, authApi),
    takeLatest(FiltersInterestTypes.FILTERS_INTEREST_CATEGORY_REQUEST, getFiltersInterestCategory, api, authApi),
    takeLatest(FiltersInterestTypes.FILTERS_INTEREST_INTEREST_REQUEST, getFiltersInterest, api, authApi),

    takeLatest(InterestsTypes.INTERESTS_REQUEST, getInterests, api, authApi),
    takeLatest(InterestsTypes.INTEREST_EXAMPLE_REQUEST, getInterestExample, api, authApi),

    takeLatest(InterestsTypes.INTEREST_FILE_REQUEST, getInterestFile, api, authApi),

    takeLatest(ListsTypes.LISTS_REQUEST, getLists, api, authApi),
    takeLatest(ListsTypes.LIST_RESTORE_REQUEST, restoreList, api, authApi),

    takeLatest(PublicationCreateTypes.PUBLICATION_CREATE_REQUEST, getPublicationCreate, api, authApi),
    takeLatest(PublicationCreateTypes.SAVE_PUBLICATION_CREATE_REQUEST, savePublicationCreate, api, authApi),
    takeLatest(PublicationCreateTypes.DELETE_PUBLICATION_CREATE_REQUEST, deletePublicationCreate, api, authApi),
    takeLatest(PublicationCreateTypes.SAVE_SELLER_REQUEST, saveSeller, api, authApi),
    takeLatest(PublicationCreateTypes.UPDATE_SELLER_REQUEST, updateSeller, api, authApi),
    takeLatest(PublicationCreateTypes.DELETE_SELLER_REQUEST, deleteSeller, api, authApi),

    takeLatest(SuggestaFutureTypes.GET_PAGES_REQUEST, getPages, api, authApi),
    takeLatest(SuggestaFutureTypes.SEND_SUGGEST_REQUEST, sendSuggest, api, authApi),
    takeLatest(SuggestaFutureTypes.SEND_HELP_REQUEST, sendHelp, api, authApi),

    takeLatest(SuggestHelpAdminReduxTypes.GET_TICKETS_REQUEST, getTickets, api, authApi),
    takeLatest(SuggestHelpAdminReduxTypes.GET_TICKET_ID_REQUEST, getTicketId, api, authApi),
    takeLatest(SuggestHelpAdminReduxTypes.DELETE_TICKET_REQUEST, deleteTicket, api, authApi),

    takeLatest(ReportAdminReduxTypes.GET_REPORTS_REQUEST, getReports, api, authApi),
    takeLatest(ReportAdminReduxTypes.GET_REPORT_ID_REQUEST, getReportId, api, authApi),
    takeLatest(ReportAdminReduxTypes.DELETE_REPORT_REQUEST, deleteReport, api, authApi),

    takeLatest(PublicationCreateTypes.SAVE_SUPPLIER_REQUEST, saveSupplier, api, authApi),
    takeLatest(PublicationCreateTypes.UPDATE_SUPPLIER_REQUEST, updateSupplier, api, authApi),
    takeLatest(PublicationCreateTypes.DELETE_SUPPLIER_REQUEST, deleteSupplier, api, authApi),

    takeLatest(PublicationCreateTypes.SAVE_MEDIA_REQUEST, saveMedia, api, authApi),
    takeLatest(PublicationCreateTypes.UPDATE_MEDIA_REQUEST, updateMedia, api, authApi),
    takeLatest(PublicationCreateTypes.DELETE_MEDIA_REQUEST, deleteMedia, api, authApi),

    takeLatest(TopPerformingTypes.TOP_PERFORMING_REQUEST, getTopPerforming, api, authApi),
    takeLatest(TopPerformingTypes.TOP_PERFORMING_ID_REQUEST, getTopPerformingId, api, authApi),
    takeLatest(TopPerformingTypes.FOLLOW_AUTHOR_TPP_REQUEST, followAuthorTpp, api, authApi),
    takeLatest(TopPerformingTypes.SAVE_TOP_PERFORMING_REQUEST, saveTopPerforming, api, authApi),
    takeLatest(TopPerformingTypes.REPORT_REASONS_TPP_REQUEST, getReportTppReasons, api, authApi),
    takeLatest(TopPerformingTypes.SEND_REPORT_TPP_REQUEST, sendTppReport, api, authApi),

    takeLatest(PermissionsTypes.PERMISSIONS_REQUEST, getPermissions, api, authApi),
    takeLatest(PermissionsTypes.PERMISSION_REQUEST, getPermission, api, authApi),
    takeLatest(PermissionsTypes.SAVE_PERMISSIONS_REQUEST, savePermissions, api, authApi),
    takeLatest(PermissionsTypes.DELETE_PERMISSIONS_REQUEST, deletePermissions, api, authApi),
    takeLatest(PermissionsTypes.PERMISSIONS_PAGES_REQUEST, getPermissionsPages, api, authApi),

    takeLatest(SettingsTypes.COUNTRIES_REQUEST, getCountries, api, authApi),
    takeLatest(SettingsTypes.SUBSCRIPTIONS_REQUEST, getSubscriptions, api, authApi),
    takeLatest(SettingsTypes.SAVE_PAYMENT_METHOD_REQUEST, savePaymentMethod, api, authApi),
    takeLatest(SettingsTypes.BUY_SUBSCRIPTION_REQUEST, buySubscription, api, authApi),
    takeLatest(SettingsTypes.UPDATE_SUBSCRIPTION_REQUEST, updateSubscription, api, authApi),
    takeLatest(SettingsTypes.SAVE_COMPANY_INFO_REQUEST, saveCompanyInfo, api, authApi),
    takeLatest(SettingsTypes.DELETE_SCHEDULED_SUBSCRIPTION_REQUEST, deleteScheduledSubscription, api, authApi),
    takeLatest(SettingsTypes.CHECK_DISCOUNT_CODE_REQUEST, checkDiscountCode, api, authApi),
    takeLatest(SettingsTypes.SAVE_PAYMENT_METHOD_MOLLIE_REQUEST, savePaymentMethodMollie, api, authApi),
    takeLatest(SettingsTypes.CHECK_STATUS_PAYMENT_REQUEST, checkStatusPayment, api, authApi),

    takeLatest(BillingHistoryTypes.BILLING_HISTORY_REQUEST, getBillingHistory, api, authApi),

    takeLatest(NotificationsTypes.NOTIFICATIONS_REQUEST, getNotifications, api, authApi),
    takeLatest(NotificationsTypes.UPDATE_NOTIFICATIONS_REQUEST, updateNotifications, api, authApi),

    takeLatest(CustomersReduxTypes.GET_CUSTOMERS_REQUEST, getCustomers, api, authApi),
    takeLatest(CustomersReduxTypes.GET_CUSTOMER_ID_REQUEST, getCustomerId, api, authApi),
    takeLatest(CustomersReduxTypes.DELETE_CUSTOMER_REQUEST, deleteCustomer, api, authApi),
    takeLatest(CustomersReduxTypes.UPDATE_CUSTOMER_ID_REQUEST, updateCustomer, api, authApi),

    //takeLatest(TemplateTypes.TEMPLATES_REQUEST, getTemplates, api, authApi),
    //takeLatest(TemplateTypes.TEMPLATE_REQUEST, getTemplate, api, authApi),
    //takeLatest(TemplateTypes.TEMPLATE_SAVE_REQUEST, saveTemplate, api, authApi),
    //takeLatest(TemplateTypes.TEMPLATE_DELETE_REQUEST, deleteTemplate, api, authApi),

    //takeLatest(LangTypes.LANGS_REQUEST, getLangs, api, authApi),
  ])
}
